import React from "react";
import ModeHeader from "@/components/ModeHeader";
import SettingsLauncher from "@/components/SettingsLauncher";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-void grid-veil">
      <ModeHeader />
      <main className="pt-14">{children}</main>
      <SettingsLauncher />
    </div>
  );
}
